import {
  Boxes,
  BookOpenText,
  Building2,
  Calculator,
  ContactRound,
  Files,
  Gavel,
  Library,
  Search,
  ScanSearch,
  Scale,
} from "lucide-react";
import { ProductShell } from "@tribunalea/ui";
import {
  APPLICATION_IDS,
  canAccessApplication,
  canAccessTool,
  TOOL_IDS,
  TRIBUNALEA_APPLICATIONS,
} from "@tribunalea/shared";

const navigation = [
  {
    label: "Instrumenta",
    items: [
      { to: "/", label: "Herramientas", icon: Boxes },
    ],
  },
  {
    label: "Información",
    items: [
      {
        to: "/expedientes",
        label: "Expedientes",
        icon: Search,
        toolId: TOOL_IDS.INSTRUMENTA_EXPEDIENTES,
      },
      {
        to: "/buscador-sentencias",
        label: "Sentencias",
        icon: Gavel,
        toolId: TOOL_IDS.INSTRUMENTA_SENTENCES,
      },
      {
        to: "/normas",
        label: "Normas",
        icon: Scale,
        toolId: TOOL_IDS.INSTRUMENTA_NORMS,
      },
      {
        to: "/jurisprudencia",
        label: "Jurisprudencia",
        icon: ScanSearch,
        toolId: TOOL_IDS.INSTRUMENTA_JURISPRUDENCE,
      },
      {
        to: "/doctrina",
        label: "Doctrina",
        icon: BookOpenText,
        toolId: TOOL_IDS.INSTRUMENTA_DOCTRINE,
      },
    ],
  },
  {
    label: "Herramientas",
    items: [
      {
        to: "/calculadora-intereses",
        label: "Calculadora de intereses",
        icon: Calculator,
        toolId: TOOL_IDS.INSTRUMENTA_JUDICIAL_INTEREST,
      },
      {
        to: "/procesador-documental",
        label: "Procesador documental",
        icon: Files,
        toolId: TOOL_IDS.INSTRUMENTA_DOCUMENT_PROCESSOR,
      },
      {
        to: "/biblioteca",
        label: "Biblioteca IA",
        icon: Library,
        toolId: TOOL_IDS.INSTRUMENTA_LIBRARY,
      },
      {
        to: "/consulta-fiscal",
        label: "Buscador de CUIT",
        icon: Building2,
        toolId: TOOL_IDS.INSTRUMENTA_TAX_ID,
      },
      {
        to: "/matriculas-profesionales",
        label: "Matrículas",
        icon: ContactRound,
        toolId: TOOL_IDS.INSTRUMENTA_PROFESSIONALS,
      },
    ],
  },
];

const portalUrl = import.meta.env.DEV
  ? "http://localhost:3000/portal"
  : "https://tribunalea.com/portal";

const accountUrl = import.meta.env.VITE_ACCOUNT_URL || (
  import.meta.env.DEV
    ? "http://localhost:5175"
    : "https://account.tribunalea.com"
);

const products = [
  {
    applicationId: APPLICATION_IDS.PRAXIS,
    name: "Praxis",
    href: import.meta.env.VITE_PRAXIS_URL || (
      import.meta.env.DEV
        ? "http://localhost:5173"
        : "https://praxis.tribunalea.com"
    ),
  },
  {
    applicationId: APPLICATION_IDS.INSTRUMENTA,
    name: "Instrumenta",
    href: import.meta.env.VITE_INSTRUMENTA_URL || (
      import.meta.env.DEV
        ? "http://localhost:5174"
        : "https://instrumenta.tribunalea.com"
    ),
  },
  {
    applicationId: APPLICATION_IDS.LEXIA,
    name: "Lexia",
    href: import.meta.env.VITE_LEXIA_URL || (
      import.meta.env.DEV
        ? "http://localhost:5176"
        : "https://lexia.tribunalea.com"
    ),
  },
  {
    applicationId: APPLICATION_IDS.CIVITA,
    name: "Civita",
    href: import.meta.env.VITE_CIVITA_URL || (
      import.meta.env.DEV
        ? "http://localhost:5179"
        : "https://civita.tribunalea.com"
    ),
  },
];

export function AppShell({
  access,
  accountAvatar,
  authEnabled,
  clerkControls,
  children,
}) {
  const visibleNavigation = navigation.map((section) => ({
    ...section,
    items: section.items.filter((item) => (
      !item.toolId || canAccessTool(access, item.toolId)
    )),
  })).filter((section) => section.items.length);
  const visibleProducts = products.filter((product) => (
    canAccessApplication(access, product.applicationId)
  ));
  const hiddenProductNames = TRIBUNALEA_APPLICATIONS
    .filter(({ id }) => !canAccessApplication(access, id))
    .map(({ name }) => name);

  return (
    <ProductShell
      productName="Instrumenta"
      products={visibleProducts}
      hiddenProductNames={hiddenProductNames}
      navigation={visibleNavigation}
      portalUrl={portalUrl}
      accountSettingsHref={`${accountUrl}/creditos`}
      accountAvatar={accountAvatar}
      workspace={access?.workspace}
      accountControls={clerkControls}
      demo={!authEnabled}
    >
      {children}
    </ProductShell>
  );
}
